import * as React from 'react';
import cx from 'classnames';

export enum CHECKBOX_STATES {
  Checked,
  Indeterminate,
  Unchecked,
}

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  value?: CHECKBOX_STATES;
  disabled?: boolean;
  checked?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      children,
      className,
      value,
      checked = false,
      disabled = false,
      size = 'md',
      ...props
    },
    ref: React.MutableRefObject<HTMLInputElement>
  ) => {
    const innerRef = React.useRef<HTMLInputElement>(null);

    React.useImperativeHandle(ref, () => innerRef.current);

    React.useEffect(() => {
      if (innerRef?.current) {
        if (value === CHECKBOX_STATES.Checked || checked) {
          innerRef.current.checked = true;
          innerRef.current.indeterminate = false;
        } else if (value === CHECKBOX_STATES.Indeterminate) {
          innerRef.current.checked = false;
          innerRef.current.indeterminate = true;
        } else {
          innerRef.current.checked = false;
          innerRef.current.indeterminate = false;
        }
      }
    }, [value, checked, innerRef]);

    return (
      <label
        className={cx('t-checkbox', {
          [className]: !!className,
          [size]: !!size,
        })}
      >
        <input type="checkbox" ref={innerRef} {...props} disabled={disabled} />
        {label ? (
          <span className="text-xs whitespace-nowrap">{label}</span>
        ) : (
          children && children
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';
export default Checkbox;
